import { render } from "./RequiredFields.vue?vue&type=template&id=72b50da1"
import script from "./RequiredFields.vue?vue&type=script&lang=js"
export * from "./RequiredFields.vue?vue&type=script&lang=js"
script.render = render

export default script